// Destino guardado quando um link protegido cai no login (ex.: link de e-mail
// do fluxo de Documentos). Depois do login — inclusive o SSO, que volta pela
// raiz — o usuário cai no mesmo destino, não na home (card 30/09/2026).
const KEY = 'nexusq:post-login-redirect';

export function savePostLoginRedirect(path: string): void {
  // Só caminhos internos: nunca uma URL externa.
  if (!path.startsWith('/') || path.startsWith('//')) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Storage indisponível (modo privado): segue para a home.
  }
}

/** Devolve e limpa o destino guardado, ou o fallback. */
export function takePostLoginRedirect(fallback = '/calendar'): string {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v) sessionStorage.removeItem(KEY);
    return v && v.startsWith('/') && !v.startsWith('//') ? v : fallback;
  } catch {
    return fallback;
  }
}
